/**
 * Platform Physics Builder (Simplified)
 *
 * Phase 4.3.3 Revision: All platforms use simple rectangle physics
 * - Perfect visual-physics alignment (both are rounded rectangles)
 * - Reliable collision detection
 * - No complex compound bodies
 */

import Phaser from 'phaser';

export class PlatformPhysicsBuilder {
  /**
   * Create simple rectangle body for all platform types
   * This matches the visual rounded rectangle perfectly
   */
  static createDefaultBody(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    height: number
  ): MatterJS.BodyType {
    const Bodies = scene.matter.bodies;
    return Bodies.rectangle(x, y, width, height, { isStatic: true }) as MatterJS.BodyType;
  }
}
